import { OptionItem } from 'app/components/display-selected-options/display-selected-options';
import { ComplexValue } from 'ui';

export const getAggregationSelectedOption = (
  selectedAggregationField: ComplexValue<number>, 
  selectedAggregationFunction: ComplexValue<number>,
  selectedUomSet: ComplexValue<number>,
  translation: any
): OptionItem => {

  const textUomSet = translation.aggregation_unit_of_measure_set;

  return {
    value: selectedAggregationFunction?.value.toString(),
    label: selectedAggregationFunction?.description,
    selections: {
      titles: [],
      values: [`${selectedAggregationField.allLevelDescription || selectedAggregationField.description}` + 
        (!!selectedUomSet?.value ? ` (${textUomSet} - ${selectedUomSet?.description})` : '')
      ],
      excludedValues: []
    }
  };
};
